export default __webpack_public_path__ + "static/media/agustin6.344c9f89.png";